import React from "react";

const PropertyCardAdmin = ({ property, onViewDetails, detailed, onImagesChange }) => {

  const handleDeleteImage = (index) => {
    if (!window.confirm("¿Eliminar esta imagen?")) return;
    const newImages = [...property.images];
    newImages.splice(index, 1); // eliminar la imagen
    onImagesChange(newImages);
  };

  const moveImage = (index, direction) => {
    const newImages = [...property.images];
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= newImages.length) return; // evitar fuera de rango
    [newImages[index], newImages[targetIndex]] = [newImages[targetIndex], newImages[index]];
    onImagesChange(newImages);
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 space-y-2">

      {/* Imagen principal */}
      {property.images.length > 0 && (
        <img
          src={property.images[0]}
          alt={property.title}
          className="w-full h-64 object-cover rounded"
        />
      )}

      <h2 className="text-xl font-bold">{property.title}</h2>
      <p>{property.location}</p>
      <p>{property.currency} {property.price}</p>

      {/* Botón toggle */}
      <button
        onClick={onViewDetails}
        className="text-blue-600 hover:underline"
      >
        {detailed ? "Ocultar detalles" : "Ver detalles"}
      </button>

      {/* Contenido detallado */}
      {detailed && (
        <div className="mt-4 space-y-2 border-t pt-4">
          <p><strong>Área:</strong> {property.area} m²</p>
          <p><strong>Dormitorios:</strong> {property.bedrooms}</p>
          <p><strong>Baños:</strong> {property.bathrooms}</p>
          <p><strong>Cocheras:</strong> {property.parking}</p>
          <p><strong>Descripción:</strong> {property.description}</p>
          <p><strong>Highlights:</strong> {property.highlights.join(", ")}</p>
          <p><strong>Lugares cercanos:</strong> {property.nearbyPlaces.join(", ")}</p>

          {/* Galería de imágenes con eliminar y reordenar */}
          <div className="grid grid-cols-2 gap-2 mt-2">
            {property.images.map((img, idx) => (
              <div key={idx} className="relative">
                <img
                  src={img}
                  alt={`Imagen ${idx + 1}`}
                  className="w-full h-32 object-cover rounded"
                />
                {/* Botón eliminar */}
                <button
                  onClick={() => handleDeleteImage(idx)}
                  className="absolute top-1 right-1 bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center hover:bg-red-800"
                >
                  ×
                </button>
                {/* Botones mover */}
                <div className="absolute bottom-1 right-1 flex gap-1">
                  <button
                    onClick={() => moveImage(idx, -1)}
                    className="bg-gray-700 text-white rounded px-1 hover:bg-gray-900"
                  >
                    ↑
                  </button>
                  <button
                    onClick={() => moveImage(idx, 1)}
                    className="bg-gray-700 text-white rounded px-1 hover:bg-gray-900"
                  >
                    ↓
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PropertyCardAdmin;